<div class="preferences-overview wrapper--spacing-horizontal" data-test="preferences-overview">
  <h1 class="text--h1">{{ 'preferences.preferences-overview.title' | translate }}</h1>
  <p>{{ 'preferences.preferences-overview.description' | translate }}</p>
  <mat-divider></mat-divider>

  @if (preferenceGroups$ | async; as preferenceGroups) {
    <div class="preferences-overview__groups spacing--padding-top">
      @for (preferenceGroup of preferenceGroups; track preferenceGroup) {
        <div class="preferences-overview__group flex--row">
          <p class="preferences-overview__preference-group-title text--bold flex--justify-start">
            {{ preferenceGroup.displayName || preferenceGroup.groupKey }}
          </p>
          <div class="preferences-overview__preference flex--column">
            @for (preference of preferenceGroup?.subGroups; track preference) {
              <div>
                <p>{{ preference.displayName || preference.subGroupKey }}</p>
                @for (deliveryOption of preference.methods; track deliveryOption) {
                  <mat-slide-toggle
                    color="primary"
                    [ngModel]="deliveryOption.isEnabled"
                    (change)="
                      this.updateUserSetting(
                        preferenceGroup.groupKey,
                        preference.subGroupKey,
                        deliveryOption.method,
                        $event.checked
                      )
                    "
                  >
                    <div class="spacing--padding-right">
                      {{ deliveryOption.displayName || deliveryOption.method }}
                    </div>
                  </mat-slide-toggle>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <agr-notification-empty
      [isEmpty]="true"
      [emptyTitle]="'cart-processing.empty-title' | translate"
      [emptyDescription]="'cart-processing.empty-description' | translate"
      [showEmptyAction]="false"
    >
    </agr-notification-empty>
  }
</div>
